import { render } from "./ListaNotaFiscal.vue?vue&type=template&id=a8dd72f6&scoped=true"
import script from "./ListaNotaFiscal.vue?vue&type=script&lang=js"
export * from "./ListaNotaFiscal.vue?vue&type=script&lang=js"

import "./ListaNotaFiscal.vue?vue&type=style&index=0&id=a8dd72f6&scoped=true&lang=css"
import "./ListaNotaFiscal.vue?vue&type=style&index=1&id=a8dd72f6&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8dd72f6"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QInput,QBtn,QTable,QIcon,QTd,QPagination,QField});
